import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import LaundryListTable from './Componate/LaundryListTable'

const LaundryList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Laundry List</HeadingOne>
                    <AddItemBtn url="add-laundry" title="Create" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <LaundryListTable />
            </div>
        </PageBody>
    )
}

export default LaundryList
